import React, { useMemo } from "react";
import TailwindIcon from "library/components/_tailwind/icon";
import { CustomIconName } from "library/components/_tailwind/icon/icons/enums";
import CustomIcon from "library/components/_tailwind/icon/icons";
import { IChatMessage } from "common/broadcast/_stores/chat/interfaces";
import { languageStore } from "library/core/stores/language/LanguageStore";
import AiChatStore from "common/broadcast/_stores/ai-chat/AiChatStore";
import { inject, observer } from "mobx-react";

type Props = {
  message: IChatMessage;
  aiChatStore?: AiChatStore;
};

const ChatMessageTip: React.ComponentType<Props> = ({
  message,
  aiChatStore,
}) => {
  const { intl } = languageStore!;
  const backgroundImage =
    "linear-gradient(90deg, #00ff37 0%, rgba(166, 255, 0, 0.7) 100% )";

  const isAiEnabled = aiChatStore!.isUiVisible;

  const cleanUsername = useMemo(() => {
    if (!message.from) return "";
    if (message.from.includes("ffadult") || message.from.includes("bdsm")) {
      return message.from.split(/_/)[0];
    }
    return message.from.split(/\+|@/)[0];
  }, [message?.from]);

  return (
    <div className='ChatItem__box' style={{ backgroundImage }}>
      <TailwindIcon name={CustomIconName.token} />
      <span data-testid={"chat-message-tip"}>
        {intl.formatMessage(
          {
            id: `broadcast.chatItem.tippedYouTkns`,
            defaultMessage: `{chatfrom} tipped you {chatValue} tokens`,
          },
          { chatfrom: message.from, chatValue: message.value }
        )}
      </span>
      {isAiEnabled && (
        <span
          style={{
            fontSize: "0.875rem",
            color: "var(--pink-color)",
            display: "inline-flex",
            verticalAlign: "middle",
            cursor: "pointer",
            marginLeft: "4px",
            opacity: 0.6,
          }}
          onClick={() =>
            aiChatStore?.requestTransactionRecommendation(
              cleanUsername,
              `[SYSTEM] ${cleanUsername} tipped ${message.value} tokens`
            )
          }>
          <CustomIcon name={"auto_awesome"} />
        </span>
      )}
    </div>
  );
};

export default inject(
  "aiChatStore"
)(observer(ChatMessageTip));
